var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.showCV)?_c('AtsCv',{attrs:{"cvId":_vm.cvId},on:{"close":_vm.closeCv}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }